import { ExternalMark, externalLinkProps } from "@softmax/web-ux/shell";
import { buildHref } from "@softmax/web-addresses";
import { signIn } from "@softmax/web-features/session/commands";
import type { ProfileSettingsData } from "../../account.types";
import { sectionLabel, bodyText, linkStyle } from "./profile-styles";
import { LinkedAccount } from "./linked-account";

export function ProfileGithub({ github }: Pick<ProfileSettingsData, "github">) {
  if (!github.linked && !github.enabled) return null;

  return (
    <section
      aria-labelledby="account-signin"
      className="flex flex-1 flex-col gap-[24px] pt-[24px]"
    >
      <h2 id="account-signin" className={sectionLabel}>
        Sign-in methods
      </h2>
      <p className={bodyText}>
        How you get into this account. More methods (such as a password or
        Google) will appear here.
      </p>
      {github.linked ? (
        <LinkedAccount
          title="GitHub"
          action={null}
          body={
            github.login !== null ? (
              <a
                href={`https://github.com/${github.login}`}
                className={linkStyle}
                {...externalLinkProps}
              >
                GitHub account linked
                <ExternalMark />
              </a>
            ) : (
              "GitHub linked, but this account is not on the Softmax team roster yet. Team features activate after the operator-run roster sync includes it."
            )
          }
        />
      ) : (
        <LinkedAccount
          title="GitHub"
          body="Link GitHub so Softmax can recognize team membership."
          action={{
            label: "Link GitHub",
            onClick: () =>
              void signIn({
                provider: "github",
                callbackUrl: buildHref({ name: "account" }),
              }),
          }}
        />
      )}
      {github.linked ? (
        <p className="font-plex-sans text-[12px] leading-[15.6px] text-[#7c7c7c]">
          There is no self-serve unlink yet. To move to a different GitHub
          account, ask the Softmax team in Discord.
        </p>
      ) : null}
    </section>
  );
}
